export default __webpack_public_path__ + "static/media/as-5.50f42960.png";